import { render } from "./reporterApplyInstitution.vue?vue&type=template&id=39af496d&scoped=true"
import script from "./reporterApplyInstitution.vue?vue&type=script&lang=js"
export * from "./reporterApplyInstitution.vue?vue&type=script&lang=js"

import "./reporterApplyInstitution.vue?vue&type=style&index=0&id=39af496d&lang=less&scoped=true"
import "./reporterApplyInstitution.vue?vue&type=style&index=1&id=39af496d&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39af496d"]])

export default __exports__